module.exports = __webpack_public_path__ + "img/gift20.618c9227.png";